module.exports = __webpack_public_path__ + "media/assets/images/condensed-cover-e90d839ea603d6b5dd4dade130be917e.svg";